export const AvatarBodyDefault = ({ id, colors }) => {
  return (
    <g id="Padrão">
      <linearGradient
        id={`${id}--SVGID_29_`}
        gradientUnits="userSpaceOnUse"
        x1="45.6554"
        y1="-53.5263"
        x2="76.6774"
        y2="-53.5263"
        gradientTransform="matrix(1 0 0 1 0 380)"
      >
        <stop
          offset="0"
          style={{ stopColor: colors[0] }}
          data-color={colors[0]}
        />
        <stop offset="0.1751" style={{ stopColor: colors[1] }} />
        <stop offset="0.5056" style={{ stopColor: colors[2] }} />
        <stop offset="0.5682" style={{ stopColor: colors[3] }} />
        <stop offset="0.7842" style={{ stopColor: colors[4] }} />
        <stop offset="1" style={{ stopColor: colors[5] }} />
      </linearGradient>
      <path
        style={{ fill: `url(#${id}--SVGID_29_)` }}
        d="M51.9,439.6c-3.2-0.5-5.6-3.3-5.6-6.6c0-13.2-0.1-46,0.3-58.5c0.6-16-2.8-48.9,0.3-77.4 c3.7-35,5.5-61,6.4-77.6c0.3-6.5,8.8-8.8,12.3-3.3l9.9,15.1c0.9,1.3,1.3,2.9,1,4.5c-1,7.6-3.9,32.2-5.9,67.3 c-1.6,28.4-5.4,58.1-6.4,73.9c-0.8,12.1-3.4,42.6-4.6,56.6C59.4,437.5,55.8,440.3,51.9,439.6L51.9,439.6z"
      />

      <linearGradient
        id={`${id}--SVGID_30_`}
        gradientUnits="userSpaceOnUse"
        x1="119.3649"
        y1="-63.7443"
        x2="81.2534"
        y2="-62.3197"
        gradientTransform="matrix(1 0 0 1 0 380)"
      >
        <stop offset="0" style={{ stopColor: colors[0] }} />
        <stop offset="0.1751" style={{ stopColor: colors[1] }} />
        <stop offset="0.5056" style={{ stopColor: colors[2] }} />
        <stop offset="0.5682" style={{ stopColor: colors[3] }} />
        <stop offset="0.7842" style={{ stopColor: colors[4] }} />
        <stop offset="1" style={{ stopColor: colors[5] }} />
      </linearGradient>
      <path
        style={{ fill: `url(#${id}--SVGID_30_)` }}
        d="M98.2,439.9c-3.9,0.2-7.2-2.8-7.4-6.7c-0.7-18.2-2.3-66.4-2.8-83.8 c-0.5-18.7-1.8-58-2.4-76.7c-0.4-12.9-3.2-51.5-3.2-51.5l20.7-27.2c0,0,2.7,59.6,3,77c0.3,19.1-1.2,59.7-0.9,78.9 c0.3,17.3-0.3,65.6-0.4,83.2C104.7,436.7,101.9,439.7,98.2,439.9L98.2,439.9z"
      />
      <g>
        <linearGradient
          id={`${id}--SVGID_32_`}
          gradientUnits="userSpaceOnUse"
          x1="107.3679"
          y1="-177.9454"
          x2="128.4069"
          y2="-177.9454"
          gradientTransform="matrix(1 0 0 1 0 380)"
        >
          <stop offset="0" style={{ stopColor: colors[0] }} />
          <stop offset="0.1751" style={{ stopColor: colors[1] }} />
          <stop offset="0.5056" style={{ stopColor: colors[2] }} />
          <stop offset="0.5682" style={{ stopColor: colors[3] }} />
          <stop offset="0.7842" style={{ stopColor: colors[4] }} />
          <stop offset="1" style={{ stopColor: colors[5] }} />
        </linearGradient>
        <path
          style={{ fill: `url(#${id}--SVGID_32_)` }}
          d="M107.5,173.9l13.1,62.2c0.4,1.9,2.1,3.2,4,3.1l0,0c2.2-0.1,3.9-2,3.8-4.2 	c-0.7-11.1-2.7-42.4-4.8-63.3c-0.4-4.1-5.6-7.5-9.6-6.8l0,0C110.2,165.7,106.8,170.1,107.5,173.9z"
        />
      </g>
      <g>
        <g>
          <linearGradient
            id={`${id}--SVGID_34_`}
            gradientUnits="userSpaceOnUse"
            x1="117.5569"
            y1="-111.737"
            x2="124.3882"
            y2="-128.8498"
            gradientTransform="matrix(1 0 0 1 0 380)"
          >
            <stop offset="0" style={{ stopColor: colors[0] }} />
            <stop offset="0.1751" style={{ stopColor: colors[1] }} />
            <stop offset="0.5056" style={{ stopColor: colors[2] }} />
            <stop offset="0.5682" style={{ stopColor: colors[3] }} />
            <stop offset="0.7842" style={{ stopColor: colors[4] }} />
            <stop offset="1" style={{ stopColor: colors[5] }} />
          </linearGradient>
          <path
            style={{ fill: `url(#${id}--SVGID_34_)` }}
            d="M118.9,273.2l4.2-6.9c1.5-2.4,2.1-5.3,1.8-8.3l0-3.4l-3.1,3.2c-0.6,1.3-1.2,5-2.4,4.4 		c-0.9-0.5-1.5-1.5-1.5-2.5c-0.1,0.1-0.3,0.2-0.4,0.3c-0.4,0.2-0.7,0.3-1.1,0.5c-1.1,0.5-1.5,2.1-1,3.1c0.2,0.5,0.6,0.9,1,1.2 		c-0.3,0.5-0.6,1.1-0.8,1.6c-0.6,1.1-0.4,2.5,0.6,3.2c0.2,0.1,0.4,0.3,0.6,0.3c-0.2,0.3-0.3,0.6-0.5,0.9 		c-1.1,1.9,0.6,3.7,2.2,3.7C118.5,274.1,118.6,273.6,118.9,273.2z"
          />
          <g>
            <linearGradient
              id="Caminho_12_"
              gradientUnits="userSpaceOnUse"
              x1="117.5586"
              y1="-111.7363"
              x2="124.3899"
              y2="-128.8491"
              gradientTransform="matrix(1 0 0 1 0 380)"
            >
              <stop offset="0" style={{ stopColor: '#FFB09A' }} />
              <stop offset="0.205" style={{ stopColor: '#FF9B8D' }} />
              <stop offset="0.4699" style={{ stopColor: '#FF8781' }} />
              <stop offset="0.7353" style={{ stopColor: '#FF7B79' }} />
              <stop offset="1" style={{ stopColor: '#FF7777' }} />
            </linearGradient>
            <path
              id="Caminho_3_"
              style={{
                opacity: '0.4',
                fill: 'url(#Caminho_12_)',
                enableBackground: 'new'
              }}
              d="M118.9,273.2l4.2-6.9 			c1.5-2.4,2.1-5.3,1.8-8.3l0-3.4l-2.9,2.5c-0.6,1.3-1.4,5.7-2.6,5c-0.9-0.5-1.5-1.5-1.5-2.5c-0.1,0.1-0.3,0.2-0.4,0.3 			c-0.4,0.2-0.7,0.3-1.1,0.5c-1.1,0.5-1.5,2.1-1,3.1c0.2,0.5,0.6,0.9,1,1.2c-0.3,0.5-0.6,1.1-0.8,1.6c-0.6,1.1-0.4,2.5,0.6,3.2 			c0.2,0.1,0.4,0.3,0.6,0.3c-0.2,0.3-0.3,0.6-0.5,0.9c-1.1,1.9,0.6,3.7,2.2,3.7C118.5,274.1,118.6,273.6,118.9,273.2z"
            />

            <linearGradient
              id="Caminho_13_"
              gradientUnits="userSpaceOnUse"
              x1="125.3043"
              y1="-127.6984"
              x2="116.9026"
              y2="-108.3564"
              gradientTransform="matrix(1 0 0 1 0 380)"
            >
              <stop offset="5.586999e-03" style={{ stopColor: '#CE77F1' }} />
              <stop offset="0.1593" style={{ stopColor: '#D280EF' }} />
              <stop offset="0.4059" style={{ stopColor: '#DC97EA' }} />
              <stop offset="0.7127" style={{ stopColor: '#EDBDE1' }} />
              <stop offset="1" style={{ stopColor: '#FFE7D8' }} />
            </linearGradient>
            <path
              id="Caminho_2_"
              style={{
                opacity: '0.4',
                fill: 'url(#Caminho_13_)',
                enableBackground: 'new',
                mixBlendMode: 'multiply'
              }}
              d="M127.4,251.3 			c-1-1.4-3.4-1.9-4.3,0c-0.9,2-2,3.9-3.2,5.7c-0.7,1.1-1.5,2.4-2.5,3c-0.4,0.2-0.7,0.3-1.1,0.5c-1.1,0.5-1.5,2.1-1,3.1 			c0.2,0.5,0.6,0.9,1,1.2c-0.3,0.5-0.6,1.1-0.8,1.6c-0.6,1.1-0.4,2.5,0.6,3.2c0.1,0.1,0.5,0.3,0.6,0.3c0.4-0.5,2.5-3,3-3.6 			c1.5-1.7,2.7-2.8,3.9-3c0.9-0.1,0.2,1.1-0.1,2.5c0.9-1.6,3.2-3.5,3.8-5.2c0.2-0.2,0.3-0.4,0.4-0.6 			C129.3,257.4,129.3,253.9,127.4,251.3z M118.6,267.5c-0.4,0.7-1.1,1.2-1.6,1.5c-0.2,0.1-0.3,0.1-0.5,0.1c0,0,0,0-0.1,0 			c-0.2,0-0.4,0-0.6-0.1c-0.7-0.4-0.7-1.8,0.1-3.1s2-1.9,2.7-1.5S119.3,266.2,118.6,267.5z"
            />
          </g>
        </g>

        <linearGradient
          id={`${id}--SVGID_35_`}
          gradientUnits="userSpaceOnUse"
          x1="116.8162"
          y1="-124.3768"
          x2="131.4495"
          y2="-124.3768"
          gradientTransform="matrix(1 0 0 1 0 380)"
        >
          <stop offset="0" style={{ stopColor: colors[0] }} />
          <stop offset="0.1751" style={{ stopColor: colors[1] }} />
          <stop offset="0.5056" style={{ stopColor: colors[2] }} />
          <stop offset="0.5682" style={{ stopColor: colors[3] }} />
          <stop offset="0.7842" style={{ stopColor: colors[4] }} />
          <stop offset="1" style={{ stopColor: colors[5] }} />
        </linearGradient>
        <path
          style={{ fill: `url(#${id}--SVGID_35_)` }}
          d="M120.6,236.1c-1.1,2.1-3.4,7.7-1.5,14.5l-2.2,8.4c-0.3,1.3,0.3,2.7,1.4,3.3l0,0 	c1.3,0.6,2.7,0,3.3-1.3l2.1-4.7l0.2,1.8c0.3,2.9-0.4,5.8-1.8,8.3l-4.2,6.9c-0.5,0.8-0.5,1.8-0.1,2.6l0,0c0.8,1.6,2.9,1.9,3.9,0.5 	l6.5-8.3c2.5-3.2,3.6-7.5,3-11.7l-2.7-21.4c-0.1-0.9-1.3-1.1-2.2-0.9l-4.3,0.9C121.4,235.1,120.9,235.5,120.6,236.1z"
        />
      </g>

      <linearGradient
        id={`${id}--SVGID_36_`}
        gradientUnits="userSpaceOnUse"
        x1="93.9356"
        y1="-224.8402"
        x2="130.6861"
        y2="-228.2528"
        gradientTransform="matrix(1 0 0 1 0 380)"
      >
        <stop offset="0" style={{ stopColor: colors[0] }} />
        <stop offset="0.1751" style={{ stopColor: colors[1] }} />
        <stop offset="0.5056" style={{ stopColor: colors[2] }} />
        <stop offset="0.5682" style={{ stopColor: colors[3] }} />
        <stop offset="0.7842" style={{ stopColor: colors[4] }} />
        <stop offset="1" style={{ stopColor: colors[5] }} />
      </linearGradient>
      <path
        style={{ fill: `url(#${id}--SVGID_36_)` }}
        d="M123.6,172.5l-5.9-48L99,128.8l8.7,46.2c0.8,4.4,5,7.2,9.3,6.5l0,0 C121.2,180.7,124.2,176.8,123.6,172.5z"
      />
      <g>
        <linearGradient
          id={`${id}--SVGID_40_`}
          gradientUnits="userSpaceOnUse"
          x1="21.36"
          y1="-175.8667"
          x2="42.6321"
          y2="-175.8667"
          gradientTransform="matrix(1 0 0 1 0 380)"
        >
          <stop offset="0" style={{ stopColor: colors[0] }} />
          <stop offset="0.1751" style={{ stopColor: colors[1] }} />
          <stop offset="0.5056" style={{ stopColor: colors[2] }} />
          <stop offset="0.5682" style={{ stopColor: colors[3] }} />
          <stop offset="0.7842" style={{ stopColor: colors[4] }} />
          <stop offset="1" style={{ stopColor: colors[5] }} />
        </linearGradient>
        <path
          style={{ fill: `url(#${id}--SVGID_40_)` }}
          d="M42.5,175.9l-13.8,65.5l-7.4-0.3c0,0,2.4-41.6,5.1-67.3c0.4-4.1,5.6-7.5,9.6-6.8l0,0 	C39.8,167.7,43.2,172.1,42.5,175.9z"
        />
      </g>
      <g>
        <g>
          <linearGradient
            id={`${id}--SVGID_41_`}
            gradientUnits="userSpaceOnUse"
            x1="-2273.46"
            y1="-110.2545"
            x2="-2266.8806"
            y2="-126.7361"
            gradientTransform="matrix(-1 0 0 1 -2240.262 380)"
          >
            <stop offset="0" style={{ stopColor: colors[0] }} />
            <stop offset="0.1751" style={{ stopColor: colors[1] }} />
            <stop offset="0.5056" style={{ stopColor: colors[2] }} />
            <stop offset="0.5682" style={{ stopColor: colors[3] }} />
            <stop offset="0.7842" style={{ stopColor: colors[4] }} />
            <stop offset="1" style={{ stopColor: colors[5] }} />
          </linearGradient>
          <path
            style={{ fill: `url(#${id}--SVGID_41_)` }}
            d="M31.8,274.5l-4.2-6.9c-1.5-2.4-2.1-5.3-1.9-8.3l0.4-2.7l2.1,4.5c0.6,1.3,1.8,3,3,2.3 		c0.9-0.5,1.5-1.5,1.5-2.5c0.1,0.1,0.3,0.2,0.4,0.3c0.4,0.2,0.7,0.3,1.1,0.5c1.1,0.5,1.5,2.1,1,3.1c-0.2,0.5-0.6,0.9-1,1.2 		c0.3,0.5,0.6,1.1,0.8,1.6c0.6,1.1,0.4,2.5-0.6,3.2c-0.2,0.1-0.4,0.3-0.6,0.3c0.2,0.3,0.3,0.6,0.5,0.9c1.1,1.9-0.5,3.7-2.2,3.7 		C32.2,275.4,32.1,274.9,31.8,274.5z"
          />
          <g>
            <linearGradient
              id="Caminho_14_"
              gradientUnits="userSpaceOnUse"
              x1="-2273.5332"
              y1="-110.0708"
              x2="-2267.1919"
              y2="-125.956"
              gradientTransform="matrix(-1 0 0 1 -2240.262 380)"
            >
              <stop offset="0" style={{ stopColor: '#FFB09A' }} />
              <stop offset="0.205" style={{ stopColor: '#FF9B8D' }} />
              <stop offset="0.4699" style={{ stopColor: '#FF8781' }} />
              <stop offset="0.7353" style={{ stopColor: '#FF7B79' }} />
              <stop offset="1" style={{ stopColor: '#FF7777' }} />
            </linearGradient>
            <path
              id="Caminho"
              style={{
                opacity: '0.4',
                fill: 'url(#Caminho_14_)',
                enableBackground: 'new'
              }}
              d="M31.8,274.5l-4.2-6.9 			c-1.5-2.4-2.1-5.3-1.9-8.3l0.2-1.8l2.4,3.7c0.6,1.3,1.8,3,3,2.3c0.9-0.5,1.5-1.5,1.5-2.5c0.1,0.1,0.3,0.2,0.4,0.3 			c0.4,0.2,0.7,0.3,1.1,0.5c1.1,0.5,1.5,2.1,1,3.1c-0.2,0.5-0.6,0.9-1,1.2c0.3,0.5,0.6,1.1,0.8,1.6c0.6,1.1,0.4,2.5-0.6,3.2 			c-0.2,0.1-0.4,0.3-0.6,0.3c0.2,0.3,0.3,0.6,0.5,0.9c1.1,1.9-0.5,3.7-2.2,3.7C32.2,275.4,32.1,274.9,31.8,274.5z"
            />

            <linearGradient
              id="Caminho_15_"
              gradientUnits="userSpaceOnUse"
              x1="-2265.6438"
              y1="-126.4142"
              x2="-2274.0454"
              y2="-107.0722"
              gradientTransform="matrix(-1 0 0 1 -2240.262 380)"
            >
              <stop offset="5.586999e-03" style={{ stopColor: '#CE77F1' }} />
              <stop offset="0.1593" style={{ stopColor: '#D280EF' }} />
              <stop offset="0.4059" style={{ stopColor: '#DC97EA' }} />
              <stop offset="0.7127" style={{ stopColor: '#EDBDE1' }} />
              <stop offset="1" style={{ stopColor: '#FFE7D8' }} />
            </linearGradient>
            <path
              id="Caminho_1_"
              style={{
                opacity: '0.4',
                fill: 'url(#Caminho_15_)',
                enableBackground: 'new',
                mixBlendMode: 'multiply'
              }}
              d="M22.9,261.4 			c0.1,0.2,0.3,0.4,0.5,0.6c0.6,1.7,2.9,3.6,3.8,5.2c-0.3-1.4-1-2.6-0.1-2.5c1.2,0.2,2.4,1.2,3.9,3c0.5,0.6,2.5,3.1,3,3.6 			c0.1-0.1,0.5-0.3,0.6-0.3c1-0.8,1.2-2.1,0.6-3.2c-0.3-0.5-0.6-1.1-0.8-1.6c0.5-0.3,0.8-0.7,1-1.2c0.5-1,0.1-2.6-1-3.1 			c-0.4-0.2-0.7-0.3-1.1-0.5c-1-0.6-1.8-1.9-2.5-3c-1.2-1.8-2.2-3.8-3.1-5.7c-0.9-1.9-3.3-1.4-4.3,0 			C21.4,255.1,21.4,258.6,22.9,261.4z M32,265.7c0.7-0.4,1.9,0.2,2.7,1.5s0.8,2.6,0.1,3.1c-0.2,0.1-0.3,0.1-0.6,0.1 			c0,0,0,0-0.1,0c-0.2,0-0.3-0.1-0.5-0.1c-0.6-0.2-1.2-0.7-1.6-1.5C31.3,267.5,31.3,266.1,32,265.7z"
            />
          </g>
        </g>

        <linearGradient
          id={`${id}--SVGID_43_`}
          gradientUnits="userSpaceOnUse"
          x1="18.7205"
          y1="-122.4194"
          x2="33.3538"
          y2="-122.4194"
          gradientTransform="matrix(1 0 0 1 0 380)"
        >
          <stop offset="0" style={{ stopColor: colors[0] }} />
          <stop offset="0.1751" style={{ stopColor: colors[1] }} />
          <stop offset="0.5056" style={{ stopColor: colors[2] }} />
          <stop offset="0.5682" style={{ stopColor: colors[3] }} />
          <stop offset="0.7842" style={{ stopColor: colors[4] }} />
          <stop offset="1" style={{ stopColor: colors[5] }} />
        </linearGradient>
        <path
          style={{ fill: `url(#${id}--SVGID_43_)` }}
          d="M29.1,237.3c0,0,4.5,6.7,2,15.4l2.2,8.4c0.3,1.3-0.3,2.7-1.4,3.3l0,0 	c-1.3,0.6-2.7,0-3.3-1.3l-2.1-4.7l-0.2,1.8c-0.3,2.9,0.4,5.8,1.9,8.3l4.2,6.9c0.5,0.8,0.5,1.8,0.1,2.6l0,0 	c-0.8,1.6-2.9,1.9-3.9,0.5l-6.5-8.3c-2.5-3.2-3.6-7.5-3-11.7l3.2-22.6L29.1,237.3z"
        />
      </g>

      <linearGradient
        id={`${id}--SVGID_45_`}
        gradientUnits="userSpaceOnUse"
        x1="30.721"
        y1="-225.3652"
        x2="47.5623"
        y2="-222.1922"
        gradientTransform="matrix(1 0 0 1 0 380)"
      >
        <stop offset="0" style={{ stopColor: colors[0] }} />
        <stop offset="0.1751" style={{ stopColor: colors[1] }} />
        <stop offset="0.5056" style={{ stopColor: colors[2] }} />
        <stop offset="0.5682" style={{ stopColor: colors[3] }} />
        <stop offset="0.7842" style={{ stopColor: colors[4] }} />
        <stop offset="1" style={{ stopColor: colors[5] }} />
      </linearGradient>
      <path
        style={{ fill: `url(#${id}--SVGID_45_)` }}
        d="M26.4,174.5l5.9-48l18.7,4.3L42.3,177c-0.8,4.4-5,7.2-9.4,6.5l0,0 C28.8,182.7,25.9,178.8,26.4,174.5z"
      />
      <g>
        <g>
          <linearGradient
            id={`${id}--SVGID_47_`}
            gradientUnits="userSpaceOnUse"
            x1="75.0596"
            y1="-288.22"
            x2="74.8816"
            y2="-158.2417"
            gradientTransform="matrix(1 0 0 1 0 380)"
          >
            <stop offset="0" style={{ stopColor: colors[0] }} />
            <stop offset="0.1751" style={{ stopColor: colors[1] }} />
            <stop offset="0.5056" style={{ stopColor: colors[2] }} />
            <stop offset="0.5682" style={{ stopColor: colors[3] }} />
            <stop offset="0.7842" style={{ stopColor: colors[4] }} />
            <stop offset="1" style={{ stopColor: colors[5] }} />
          </linearGradient>
          <path
            id={`${id}--SVGID_37_`}
            style={{ fill: `url(#${id}--SVGID_47_)` }}
            d="M117.8,125.1c-0.6-7.7-6.3-18.7-19.3-21c-20.4-3.6-43.3,0-43.3,0 		s-21.1,4.7-23,22.4C31.4,134.8,50,136,50,136l4.4,52.4h0c-0.3,2.2-0.5,4.6-0.5,6.9c0,18.4,11,33.4,24.6,33.4 		s24.6-14.9,24.6-33.4c0-2.6-0.2-5.2-0.7-7.6l-0.1-54.8C102.3,133,118.1,129.5,117.8,125.1z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id={`${id}--SVGID_48_`}
                d="M117.8,125.1c-0.6-7.7-6.3-18.7-19.3-21c-20.4-3.6-43.3,0-43.3,0s-21.1,4.7-23,22.4 				C31.4,134.8,50,136,50,136l4.4,52.4h0c-0.3,2.2-0.5,4.6-0.5,6.9c0,18.4,11,33.4,24.6,33.4s24.6-14.9,24.6-33.4 				c0-2.6-0.2-5.2-0.7-7.6l-0.1-54.8C102.3,133,118.1,129.5,117.8,125.1z"
              />
            </defs>
            <clipPath id={`${id}--SVGID_50_`}>
              <use xlinkHref="#SVGID_48_" style={{ overflow: 'visible' }} />
            </clipPath>

            <linearGradient
              id={`${id}--SVGID_51_`}
              gradientUnits="userSpaceOnUse"
              x1="75.4438"
              y1="-274.9178"
              x2="73.9357"
              y2="-227.9502"
              gradientTransform="matrix(1 0 0 1 0 380)"
            >
              <stop offset="0" style={{ stopColor: colors[0] }} />
              <stop offset="0.1751" style={{ stopColor: colors[1] }} />
              <stop offset="0.5056" style={{ stopColor: colors[2] }} />
              <stop offset="0.5682" style={{ stopColor: colors[3] }} />
              <stop offset="0.7842" style={{ stopColor: colors[4] }} />
              <stop offset="1" style={{ stopColor: colors[5] }} />
            </linearGradient>
            <path
              style={{
                clipPath: `url(#${id}--SVGID_50_)`,
                fill: `url(#${id}--SVGID_51_)`
              }}
              d="M90.7,142.7H63.8c-4.2,0-13.9-0.6-13.9-7.1l-29.8-1.1 			L42,94.3l64.7,1.2l22.4,30.3l-27,8.5C102.2,140.7,97.2,142.7,90.7,142.7z"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <linearGradient
            id={id + 'SVGID_53_'}
            gradientUnits="userSpaceOnUse"
            x1="76.679"
            y1="-249.0202"
            x2="77.0811"
            y2="-299.0508"
            gradientTransform="matrix(1 0 0 1 0 380)"
          >
            <stop offset="0" style={{ stopColor: colors[0] }} />
            <stop offset="0.1751" style={{ stopColor: colors[1] }} />
            <stop offset="0.5056" style={{ stopColor: colors[2] }} />
            <stop offset="0.5682" style={{ stopColor: colors[3] }} />
            <stop offset="0.7842" style={{ stopColor: colors[4] }} />
            <stop offset="1" style={{ stopColor: colors[5] }} />
          </linearGradient>
          <path
            style={{ fill: `url(#${id}SVGID_53_)` }}
            d="M84.7,98.2L82.3,79l-12,0.3l-2.3,18.8l-12.8,6c0,0,22.8,45.3,43.3,0 		L84.7,98.2z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id={`${id}--SVGID_54_`}
                d="M84.7,98.2L82.3,79l-12,0.3l-2.3,18.8l-12.8,6c0,0,22.8,45.3,43.3,0L84.7,98.2z"
              />
            </defs>
            <clipPath id={`${id}--SVGID_56_`}>
              <use xlinkHref="#SVGID_54_" style={{ overflow: 'visible' }} />
            </clipPath>

            <linearGradient
              id={`${id}--SVGID_57_`}
              gradientUnits="userSpaceOnUse"
              x1="74.5039"
              y1="-299.0356"
              x2="74.5039"
              y2="-274.085"
              gradientTransform="matrix(1 0 0 1 0 380)"
            >
              <stop offset="5.586999e-03" style={{ stopColor: '#CE77F1' }} />
              <stop offset="0.1593" style={{ stopColor: '#D280EF' }} />
              <stop offset="0.4059" style={{ stopColor: '#DC97EA' }} />
              <stop offset="0.7127" style={{ stopColor: '#EDBDE1' }} />
              <stop offset="1" style={{ stopColor: '#FFE7D8' }} />
            </linearGradient>
            <path
              style={{
                opacity: '0.6',
                clipPath: `url(#${id}--SVGID_56_)`,
                fill: `url(#${id}--SVGID_57_)`,
                enableBackground: 'new',
                mixBlendMode: 'multiply'
              }}
              d="M63.5,88.5 			c0.1,4.2,22.5,13.1,22,9C84.1,85.9,82.7,85,82.7,85S63.4,84.7,63.5,88.5z"
            />
          </g>
        </g>
      </g>

      <linearGradient
        id={`${id}--SVGID_58_`}
        gradientUnits="userSpaceOnUse"
        x1="78.965"
        y1="-76.2418"
        x2="78.965"
        y2="-199.0024"
        gradientTransform="matrix(1 0 0 1 0 380)"
      >
        <stop offset="5.586999e-03" style={{ stopColor: '#969696' }} />
        <stop offset="0.1299" style={{ stopColor: '#8D8D8D' }} />
        <stop offset="0.3294" style={{ stopColor: '#767676' }} />
        <stop offset="0.5791" style={{ stopColor: '#505050' }} />
        <stop offset="0.8667" style={{ stopColor: '#1B1B1B' }} />
        <stop offset="1" style={{ stopColor: '#000000' }} />
      </linearGradient>
      <path
        style={{ fill: `url(#${id}--SVGID_58_)` }}
        d="M104.1,201.9H78.9h-25c0,0-1.5,4.4-2.3,22.4c-0.1,1.6,1,3,2.6,3.8l15.7,7.1 c5.7,2.6,12.5,2.6,18.2,0l15.9-6.9c1.6-0.7,2.6-2.2,2.6-3.8C105.8,208.5,104.1,201.9,104.1,201.9z"
      />

      <linearGradient
        id={`${id}--SVGID_59_`}
        gradientUnits="userSpaceOnUse"
        x1="79.1361"
        y1="-192.4156"
        x2="78.9036"
        y2="-202.7235"
        gradientTransform="matrix(1 0 0 1 0 380)"
      >
        <stop offset="5.586999e-03" style={{ stopColor: '#CE77F1' }} />
        <stop offset="0.1593" style={{ stopColor: '#D280EF' }} />
        <stop offset="0.4059" style={{ stopColor: '#DC97EA' }} />
        <stop offset="0.7127" style={{ stopColor: '#EDBDE1' }} />
        <stop offset="1" style={{ stopColor: '#FFE7D8' }} />
      </linearGradient>
      <ellipse
        style={{
          opacity: '0.4',
          fill: `url(#${id}--SVGID_59_)`,
          enableBackground: 'new',
          mixBlendMode: 'multiply'
        }}
        cx="79.1"
        cy="184.2"
        rx="0.5"
        ry="2"
      />
    </g>
  )
}
